import { useStore } from "app/context";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Modal } from "../Modal";
import { Field, Form, Formik } from "formik";
import FormField from "../form/FormField";
import { DatePickerField } from "../form/DatePickerField";
import { Button } from "../common/Button";
import * as Yup from 'yup';
import { ImportDataType } from "app/stores/admin.imports.store";
import { runInAction } from "mobx";
import { useHistory } from "react-router";
import routes from "routes";
import { FindDatenStandType, DatenStandType } from "app/stores/datenstand.store";
import { extractKWFromFileName } from "app/stores/ui/admin.file.upload.ui.store";
import { ShowBmDataQualtiyForDataType } from "../shared/ShowBmDataQualtiyForDataType";


const DateStandSchema = Yup.object({
    stand: Yup.date().required('Datum ist erfoderlich').default(new Date()),
    zusatz: Yup.string(),
    kw: Yup.number()
}).required();

type DatenStandForm = Yup.InferType<typeof DateStandSchema>;

interface IDatenStandEntryModal {
    dataType: ImportDataType;
    onClose: (fileName?: string) => void
}

export const AdminFileUploadFileNameModal = observer((props: IDatenStandEntryModal) => {
    const { uiStore, adminFileUploadUiStore, adminImportsUiStore, adminDatenStandStore: datenStandStore } = useStore();
    const history = useHistory();

    useEffect(() => {
        datenStandStore.findAll().then(res => {
            const datenStand = res.find(x => x.dataType === props.dataType);
            if (datenStand && datenStand.stand) {
                setInitialDs(datenStand.stand)
            }
            if (adminFileUploadUiStore.orgUploadDate) {
                setInitialDs(adminFileUploadUiStore.orgUploadDate);
            }
        })
    }, [adminFileUploadUiStore.orgUploadDate]);


    const [initialDs, setInitialDs] = useState<Date>(new Date());
    const [dst, setDst] = useState<DatenStandType | undefined>(undefined);

    useEffect(() => {
        const datenStandType = FindDatenStandType(props.dataType);
        setDst(datenStandType);
    }, [props.dataType]);
    const onClose = () => {
        adminFileUploadUiStore.newFilename = 'cancel';
        adminFileUploadUiStore.onFileUploaded = undefined;
    };

    const uselessDefault = 202912;

    const handleSubmit = async (values: DatenStandForm) => {
        runInAction(() => {
            if (dst && dst.requireKwInput && values.kw === uselessDefault) {
                alert("bitte sinnvolle kw/bm eingeben!")
                return;
            }
            adminFileUploadUiStore.newFilename = adminFileUploadUiStore.calcNewFileName(values.stand, dst!, values.zusatz, values.kw);
            adminFileUploadUiStore.onFileUploaded = async () => {
                if (!adminFileUploadUiStore.newFilename) {
                    alert(" no new filename");
                    return;
                }
                if (!adminImportsUiStore.newJob) {
                    alert(" no new job");
                    return;
                }
                const job = adminFileUploadUiStore.prepareJobForTrigger(adminFileUploadUiStore.newFilename, adminImportsUiStore.newJob.job)
                if (!job) {
                    return;
                }
                const res: any = await adminImportsUiStore.triggerJob(job);
                history.push(routes.ADMINIMPORTS.getPath('job', res.id));

                // prevents auto-triggering in other (aup) admin-file uploads
                adminFileUploadUiStore.onFileUploaded = undefined;
            }
        })
    };

    return (
        <Modal modalId={uiStore.modalIds.adminFileUploadRenamFile} title={'Importdatei benennen'} onClose={onClose} size='large'>
            <Formik
                validationSchema={DateStandSchema}
                initialValues={{
                    stand: initialDs,
                    zusatz: undefined,
                    kw: extractKWFromFileName(adminFileUploadUiStore.orgFilename || '') || uselessDefault
                }}
                onSubmit={handleSubmit}
            >
                {({ errors, touched, isValid, values }) => {
                    return (
                        <Form>
                            <div className="pad-1rem">
                                <strong>{adminFileUploadUiStore.orgFilename} {'->'} {adminFileUploadUiStore.calcNewFileName(values.stand, dst!, values.zusatz, values.kw)}</strong>
                                <FormField className="is-inline" error={errors.stand ? String(errors.stand) : undefined} touched={touched.stand ? true : false} label="Datestand">
                                    <DatePickerField name="stand" />
                                </FormField>
                                <FormField className="is-inline" error={errors.stand ? String(errors.zusatz) : undefined} touched={touched.zusatz ? true : false} label="Zusatz">
                                    <Field type="text" name="zusatz" placeholder="Zusatz" />
                                </FormField>
                                <br />

                                {dst && dst?.requireKwInput &&
                                    <>
                                        <FormField className="is-inline" error={errors.stand ? String(errors.kw) : undefined} touched={touched.kw ? true : false} label="Berichtsmonat">
                                            <Field type="text" name="kw" placeholder="Berichtsmonat" />
                                        </FormField>

                                    </>

                                }

                                <br />
                                <Button type="submit" className={'button is-primary'} >
                                    Namen festlegen und Import Starten
                                </Button>
                                <Button type="button" className={'button is-secondary'} onClick={onClose} >
                                    Abbrechen
                                </Button>
                                <br />
                            </div>
                            {/* For the datepicker  */}
                            <div className="pad-1rem"></div><div className="pad-1rem"></div><div className="pad-1rem"></div><div className="pad-1rem"></div><div className="pad-1rem"></div><div className="pad-1rem"></div>

                            <ShowBmDataQualtiyForDataType dataType={props.dataType} />

                        </Form>
                    );
                }}
            </Formik>
        </Modal>
    );
});